module.exports = __webpack_public_path__ + "img/Vector 39.16939ef2.png";